import React, { useEffect } from "react";
import useStyles from "./style";
import { Controller } from "react-hook-form";
import {
  Select,
  Input,
  Chip,
  ListItemText,
  Checkbox,
  MenuItem,
  Tooltip,
} from "@material-ui/core";
import { renderErrorCreatePool } from "../../utils/validate";

const countries = require("../../pages/PoolCreate/Components/ForbiddenCountry/countries.json");

function ForbiddenCountry({ setValue, errors, poolDetail, control }: any) {
  const classes = useStyles();

  useEffect(() => {
    const source = poolDetail?.forbidden_countries;
    if (Array.isArray(source) && source.length > 0) {
      const normalized = source.map((c: any) =>
        typeof c === "string" ? c : c.code || c.country
      );
      setValue("forbidden_countries", normalized);
    }
  }, [poolDetail?.forbidden_countries, setValue]);

  return (
    <div>
      <div className={classes.formControl}>
      <Tooltip title="Users from these countries are completely restricted and cannot participate in the IDO pool or any related activities."
          placement="top-start"
          style={{
            fontSize: '16px'
          }}
        >
          <label className={classes.formControlLabel}>Forbidden Countries</label>
        </Tooltip>
        <Controller
          control={control}
          name="forbidden_countries"
          defaultValue={[
            "CAN",
            "USA",
            "CHN",
            "MMR",
            "HKG",
            "IRN",
            "IRQ",
            "SDN",
            "SYR",
          ]}
          render={(field) => (
            <Select
              className={classes.formControlInput}
              multiple
              value={field.value}
              onChange={field.onChange}
              input={<Input />}
              renderValue={(value: any) => (
                <div>
                  {value.map((val: any) => (
                    <Chip
                      key={val}
                      label={val}
                      style={{ marginRight: ".5rem" }}
                    />
                  ))}
                </div>
              )}
            >
              {countries.map((country: any) => (
                <MenuItem key={country.code} value={country.code}>
                  <Checkbox checked={field.value.includes(country.code)} />
                  <ListItemText primary={country.name} />
                </MenuItem>
              ))}
            </Select>
          )}
        />
        <p className={classes.formErrorMessage}>
          {renderErrorCreatePool(errors, "forbidden_countries")}
        </p>
      </div>
    </div>
  );
}

export default ForbiddenCountry;
